<template>
  <div class="content">
    <h3> Endereços: </h3>
    <div class="line">
      <div class="col12">
        <h3> Áreas de Entrega:</h3>
        <button style="width:150px;height:30px;" @click="openModalAddress()">Nova área de entrega</button>
        <br/><br/>
        <table style="border-collapse:collapse; width:100%; border:1px solid #706C7A;text-align:center;" border="1"
               cellpading="5px">
          <tr>
            <td style="width:90px;">Preço</td>
            <td style="width:90px;">Estimativa em dias</td>
            <td style="width:60px;">Ordem</td>
            <td style="width:120px;">Tipo de Entrega</td>
            <td>Coordenadas</td>
            <td style="width:90px;">Ações</td>
          </tr>
          <tr v-for="(addr, idxa) in $store.state.company.adresses" v-bind:key="idxa">
            <td>{{addr.kmlPrice}}</td>
            <td>{{addr.estimation}}</td>
            <td>{{addr.order}}</td>
            <td>{{ (addr.delivery_partner ? addr.delivery_partner : 'Entrega própria') }}</td>
            <td style="max-width:300px;">
              <div style="width:100%;height:40px;overflow:auto;">{{addr.coordinates}}</div>
            </td>
            <td>
              <a @click="openModalAddress(addr)">
                <font-awesome-icon style="font-size:18px;color:#12FCC4;margin:5px;" :icon="['fal', 'edit']"/>
              </a>
              <a @click="removeAddress(addr)">
                <font-awesome-icon style="font-size:18px;color:#bb3f5c;margin:5px;" :icon="['fal', 'trash-alt']"/>
              </a>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="line">
      <div class="col12">
        <h3>Marcadores / Endereços de contato:</h3>
        <button style="width:150px;height:30px;" @click="openModalPinAddress()">Novo Marcador</button>
        <br/><br/>
        <table style="border-collapse:collapse; width:100%; border:1px solid #706C7A;text-align:center;" border="1"
               cellpading="5px">
          <tr>
            <td>Endereço</td>
            <td>Latitude</td>
            <td>Longitude</td>
            <td style="width:70px;">Aceita retirada</td>
            <td style="width:90px;">Ações</td>
          </tr>
          <tr v-for="(paddr, idxp) in $store.state.company.pinAdresses" v-bind:key="idxp">
            <td style="height:40px;text-align:left;padding-left:10px;">{{paddr.address}}</td>
            <td>{{paddr.lat}}</td>
            <td>{{paddr.lng}}</td>
            <td>{{paddr.retrieve}}</td>
            <td>
              <a @click="openModalPinAddress(paddr)">
                <font-awesome-icon style="font-size:18px;color:#12FCC4;margin:5px;" :icon="['fal', 'edit']"/>
              </a>
              <a @click="removePinAddress(paddr)">
                <font-awesome-icon style="font-size:18px;color:#bb3f5c;margin:5px;" :icon="['fal', 'trash-alt']"/>
              </a>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="line">
      <div class="col6">
        <h3> Tela de Mapa:</h3>
        (Título) Horário de entrega: <br/><input type="text" class="inputWire"
                                                 v-model="$store.state.company.delivery_retrieve"/>
        <br/><br/>
        (Título) Horário de retirada: <br/><input type="text" class="inputWire"
                                                  v-model="$store.state.company.delivery_taking"/>
        <br/><br/>
        (Título) Informações adicionais: <br/><input type="text" class="inputWire"
                                                     v-model="$store.state.company.delivery_add_info"/>
        <br/><br/>
        Zoom google maps: <br/><input type="text" class="inputWire" v-model="$store.state.company.in_map_zoom"/>
        <br/><br/>
      </div>
      <div class="col6">
        <h3> Informações de Frete:</h3>
        Retirar na loja: <br/>
        Sim <input type="radio" :value="true" v-model="$store.state.company.delivery_properties.store_taking"/>
        Não <input type="radio" :value="false" v-model="$store.state.company.delivery_properties.store_taking"/>
        <br/><br/>
        Pedido mínimo para entrega em R$: <br/><input type="number" class="inputWire"
                                                      v-model.number="$store.state.company.delivery_properties.minimum_purchase_value"/>
        <br/><br/>
        Frete grátis para compras a partir de R$: <br/><input type="number" class="inputWire"
                                                              v-model.number="$store.state.company.delivery_properties.free_shipping_order_value"/>
        <br/><br/>
        (Legenda) Informa preço área: <br/>
        Sim <input type="radio" :value="true" v-model="$store.state.company.show_inmap_price"/>
        Não <input type="radio" :value="false" v-model="$store.state.company.show_inmap_price"/>
        <br/><br/>
        (Legenda) Informa estimativa área: <br/>
        Sim <input type="radio" :value="true" v-model="$store.state.company.show_inmap_estimate"/>
        Não <input type="radio" :value="false" v-model="$store.state.company.show_inmap_estimate"/>
      </div>
    </div>
    <div class="line">
      <div class="col12">
        <button @click="saveKeys()">Salvar</button>
      </div>
    </div>
    <OpaModal v-if="tempAddress" width="900" height="520" v-model="modalAddress" header="Endereço">
      <div style="height:380px;overflow:auto; padding:20px;">
        <div class="line" style="margin-top:0px;">
          <div class="col6" style="padding-top:0px;padding-bottom:0px;">
            Preço: <br/>
            <input type="number" class="inputText" v-model.number="tempAddress.kmlPrice"/><br/><br/>
            Estivativa em dias: <br/>
            <input type="number" class="inputText" v-model.number="tempAddress.estimation"/><br/><br/>
            Ordem: <br/>
            <input type="number" class="inputText" v-model.number="tempAddress.order"/><br/><br/>
            Tipo de entrega: <br/>
            <select v-model="tempAddress.delivery_partner">
              <option :value="null" selected>Entrega própria</option>
              <option value="BOXDELIVERY">Box Delivery</option>
            </select>
          </div>
          <div class="col6" style="padding-top:0px;padding-bottom:0px;">
            Coordenadas: <br/>
            <OpaTextarea style="width:380px;height:300px;" v-model="tempAddress.coordinates"></OpaTextarea>
          </div>
        </div>
      </div>
      <div class="modal_footer">
        <button class="buttonFlat" style="width:80px;float:right;margin:20px;margin-right:20px;" @click="saveAddress()">
          Salvar
        </button>
        <button class="buttonWire" style="width:80px;float:right;margin:20px;margin-right:0px;"
                @click="resetAddress(); modalAddress=!modalAddress">Cancelar
        </button>
      </div>
    </OpaModal>

    <OpaModal v-if="tempPinAddress" width="900" height="450" v-model="modalPinAddress" header="Endereço">
      <div style="height:280px;overflow:auto; padding:20px;">
        <div class="line" style="margin-top:0px;">
          <div class="col12" style="padding-top:0px;padding-bottom:0px;">
            Endereço: <br/>
            <input type="text" class="inputText" v-model="tempPinAddress.address"/><br/><br/>
            Latitude: <br/>
            <input type="number" class="inputText" v-model="tempPinAddress.lat"/><br/>
            Longitude: <br/>
            <input type="number" class="inputText" v-model="tempPinAddress.lng"/><br/><br/>
            Aceita Retirada?: <br/>
            Sim <input type="radio" :value="true" v-model="tempPinAddress.retrieve"/>
            Não <input type="radio" :value="false" v-model="tempPinAddress.retrieve"/>
          </div>
        </div>
      </div>
      <div class="modal_footer">
        <button class="buttonFlat" style="width:80px;float:right;margin:20px;margin-right:20px;"
                @click="savePinAddress()">Salvar
        </button>
        <button class="buttonWire" style="width:80px;float:right;margin:20px;margin-right:0px;"
                @click="resetPinAddress(); modalPinAddress=!modalPinAddress">Cancelar
        </button>
      </div>
    </OpaModal>
  </div>
</template>

<script>
  import OpaModal from '@/components/OpaModal.vue'
  import OpaTextarea from '@/components/OpaTextarea.vue'
  import {mapGetters} from 'vuex'
  import {EventBus} from '@/utils/event-bus'
  import axios from 'axios'
  import Address from '@/connection/Address'

  export default {

    components: {OpaModal, OpaTextarea},

    data() {
      return {
        tempAddress: {},
        modalAddress: false,
        tempPinAddress: {},
        modalPinAddress: false
      }
    },

    computed: {
      ...mapGetters(['getOpaApi']),
    },

    created() {
      if (!this.$store.state.company.delivery_properties) {
        this.$store.state.company.delivery_properties = {
          store_taking: false,
          minimum_purchase_value: 0,
          free_shipping_order_value: 0
        }
      }
      this.resetAddress()
      this.resetPinAddress()
    },

    methods: {

      resetAddress() {
        this.tempAddress = {
          order: null,
          isKml: true,
          coordinates: [],
          kmlPrice: 0,
          estimation: 0,
          delivery_partner: null
        }
      },

      resetPinAddress() {
        this.tempPinAddress = {
          address: null,
          lat: 0,
          lng: 0,
          retrieve: false
        }
      },

      openModalAddress(address) {
        if (address) {
          this.tempAddress = address
          if (!address.delivery_partner) {
            this.tempAddress.delivery_partner = null
          }
        }
        this.modalAddress = true
      },

      openModalPinAddress(pinAddress) {
        if (pinAddress) {
          this.tempPinAddress = pinAddress
        }
        this.modalPinAddress = true
      },

      async removeAddress(address) {
        if (confirm('Deseja realmente excluir o endereço?')) {
          EventBus.$emit('showLoading', true)
          let result = await Address.removeAddress(address.id)
          if (result.error) {
            EventBus.$emit('showLoading', false)
            EventBus.$emit('showAlert', 'error', 'erro ao remover endereço')
          } else {
            this.$store.commit('setCompany', result)
            EventBus.$emit('showLoading', false)
            EventBus.$emit('showAlert', 'success', 'endereço removido')
          }
        }
      },

      async removePinAddress(pinAddress) {
        if (confirm('Deseja realmente excluir o marcador?')) {
          EventBus.$emit('showLoading', true)
          let result = await Address.removePinAddress(pinAddress.id)
          if (result.error) {
            EventBus.$emit('showLoading', false)
            EventBus.$emit('showAlert', 'error', 'erro ao remover endereço')
          } else {
            this.$store.commit('setCompany', result)
            EventBus.$emit('showLoading', false)
            EventBus.$emit('showAlert', 'success', 'endereço removido')
          }
        }
      },

      async saveAddress() {
        EventBus.$emit('showLoading', true)
        console.log(this.tempAddress)
        let result = await Address.saveAddress(this.tempAddress)
        if (result.error) {
          EventBus.$emit('showLoading', false)
          EventBus.$emit('showAlert', 'error', 'erro ao salvar endereço')
        } else {
          this.$store.commit('setCompany', result)
          EventBus.$emit('showLoading', false)
          EventBus.$emit('showAlert', 'success', 'endereço salvo')
          this.modalAddress = false
          this.resetAddress()
        }
      },

      async savePinAddress() {
        EventBus.$emit('showLoading', true)
        let result = await Address.savePinAddress(this.tempPinAddress)
        if (result.error) {
          EventBus.$emit('showLoading', false)
          EventBus.$emit('showAlert', 'error', 'erro ao salvar marcador')
        } else {
          console.log(result)
          this.$store.commit('setCompany', result)
          EventBus.$emit('showLoading', false)
          EventBus.$emit('showAlert', 'success', 'marcador salvo')
          this.modalPinAddress = false
          this.resetPinAddress()
        }
      },

      async saveKeys() {
        let vm = this
        try {
          EventBus.$emit('showLoading', true)
          let result = await axios.patch(this.getOpaApi + '/company/' + this.$store.state.company.Id,
            {
              delivery_retrieve: vm.$store.state.company.delivery_retrieve,
              delivery_taking: vm.$store.state.company.delivery_taking,
              delivery_add_info: vm.$store.state.company.delivery_add_info,
              delivery_properties: vm.$store.state.company.delivery_properties,
              show_inmap_price: vm.$store.state.company.show_inmap_price,
              show_inmap_estimate: vm.$store.state.company.show_inmap_estimate,
              in_map_zoom: vm.$store.state.company.in_map_zoom
            })
          if (result.data) {
            console.log(result.data)
            this.$store.commit('setCompany', result.data)
          }
          EventBus.$emit('showLoading', false)
          EventBus.$emit('showAlert', 'success', 'informações atualizadas')
        } catch (e) {
          let error = {e}
          console.log(error)
          EventBus.$emit('showAlert', 'error', 'erro ao atualizar informações')
          EventBus.$emit('showLoading', false)
        }
      }
    }
  }
</script>

<style>
  a {
    cursor: pointer;
  }
</style>
